import { render, staticRenderFns } from "./FilmBox.vue?vue&type=template&id=27f07df6&scoped=true&"
import script from "./FilmBox.vue?vue&type=script&lang=ts&"
export * from "./FilmBox.vue?vue&type=script&lang=ts&"
import style0 from "./FilmBox.vue?vue&type=style&index=0&id=27f07df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f07df6",
  null
  
)

export default component.exports